import type { ScriptType } from './types';

export const DEFAULT_DELAY = 0;

export const delayTime: Record<ScriptType, number> = {
  quora: 10000,
  tiktok: 10000,
  linkedin: 5000,
  facebook: 5000,
  fullstory: 5000,
  userleap: 10000,
};
